const token = {
    local: "d83f7ca2f69cb385f04d6eb85ceed98a",
    dev: "d83f7ca2f69cb385f04d6eb85ceed98a",
    prod: "f969cd0455c4c7f492734ae9022deb4d"
}

export default token.prod